<template>
  <div class="sidebar" v-if="isLoggedIn">
    <div class="sidebar-content">
      <div class="sidebar-header">
        <img v-if="avatar" :src="avatar" alt="Avatar" class="sidebar-avatar" />
        <div v-else class="sidebar-avatar-placeholder">
          <font-awesome-icon :icon="['fas', 'user']" />
        </div>
        <h5 class="sidebar-username">{{ username }}</h5>
      </div>
      
      <!-- Menu Groups -->
      <div class="sidebar-menu-container">
        <!-- Bacaan Group -->
        <div class="menu-group">
          <div class="menu-group-title">
            <font-awesome-icon :icon="['fas', 'book']" />
            <span>Bacaan</span>
          </div>
          <ul class="sidebar-menu">
            <li>
              <router-link to="/my-reads" class="sidebar-item">
                <font-awesome-icon :icon="['fas', 'history']" />
                <span>Riwayat Baca</span>
              </router-link>
            </li>
            <li>
              <router-link to="/collections" class="sidebar-item">
                <font-awesome-icon :icon="['fas', 'bookmark']" />
                <span>Koleksi</span>
              </router-link>
            </li>
            <!--li>
              <router-link to="/reading-notes" class="sidebar-item">
                <font-awesome-icon :icon="['fas', 'sticky-note']" />
                <span>Catatan Baca</span>
              </router-link>
            </li-->
            <li>
              <router-link to="/reading-stats" class="sidebar-item">
                <font-awesome-icon :icon="['fas', 'chart-bar']" />
                <span>Statistik Baca</span>
              </router-link>
            </li>
          </ul>
        </div>

        <!-- NEW: Karyaku Group -->
        <div v-if="role === 'writer'" class="menu-group">
          <div class="menu-group-title">
            <font-awesome-icon :icon="['fas', 'pen-fancy']" />
            <span>Karyaku</span>
          </div>
          <ul class="sidebar-menu">
            <li>
              <router-link to="/my-books" class="sidebar-item">
                <font-awesome-icon :icon="['fas', 'book-open']" />
                <span>Bukuku</span>
              </router-link>
            </li>
            
            
          </ul>
        </div>
        <!-- NEW: Referral Group -->
        <div class="menu-group">
          <div class="menu-group-title">
            <font-awesome-icon :icon="['fas', 'user-plus']" />
            <span>Referral</span>
          </div>
          <ul class="sidebar-menu">
            <li>
              <router-link to="/referral-code" class="sidebar-item">
                <font-awesome-icon :icon="['fas', 'hashtag']" />
                <span>Kode Referral</span>
              </router-link>
            </li>
            <li>
              <router-link to="/referral-list" class="sidebar-item">
                <font-awesome-icon :icon="['fas', 'users']" />
                <span>Daftar Referral</span>
              </router-link>
            </li>
            <li>
              <router-link to="/my-earnings" class="sidebar-item">
                <font-awesome-icon :icon="['fas', 'money-bill-wave']" />
                <span>Penghasilanku</span>
              </router-link>
            </li>
          </ul>
        </div>
        <!-- NEW: Keuangan Group -->
        <div class="menu-group">
          <div class="menu-group-title">
            <font-awesome-icon :icon="['fas', 'wallet']" />
            <span>Keuangan</span>
          </div>
          <ul class="sidebar-menu">
            <li>
              <router-link to="/my-accounts" class="sidebar-item">
                <font-awesome-icon :icon="['fas', 'credit-card']" />
                <span>Rekening Bank</span>
              </router-link>
            </li>
            <li>
              <router-link to="/my-invoices" class="sidebar-item">
                <font-awesome-icon :icon="['fas', 'money-check']" />
                <span>Riwayat Penarikan</span>
              </router-link>
            </li>
          </ul>
        </div>
        <!-- Bantuan Group -->
        <div class="menu-group">
          <div class="menu-group-title">
            <font-awesome-icon :icon="['fas', 'question-circle']" />
            <span>Bantuan</span>
          </div>
          <ul class="sidebar-menu">
            <li>
              <router-link to="/help-center" class="sidebar-item">
                <font-awesome-icon :icon="['fas', 'info-circle']" />
                <span>Pusat Bantuan</span>
              </router-link>
            </li>
            <li>
              <router-link to="/contact" class="sidebar-item">
                <font-awesome-icon :icon="['fas', 'envelope']" />
                <span>Hubungi Kami</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/eventBus';

export default {
  name: 'Sidebar',
  data() {
    return {
      username: '',
      avatar: '',
      isLoggedIn: false,
      role: ''
    }
  },
  created() {
    // Set initial auth state
    this.updateAuthState();
    
    // Listen for auth events
    eventBus.on('login-success', this.updateAuthState);
    eventBus.on('logout-success', this.updateAuthState);
    eventBus.on('register-success', this.updateAuthState);
  },
  beforeUnmount() {
    // Clean up event listeners
    eventBus.off('login-success', this.updateAuthState);
    eventBus.off('logout-success', this.updateAuthState);
    eventBus.off('register-success', this.updateAuthState);
  },
  methods: {
    updateAuthState() {
      const token = localStorage.getItem('token');
      this.isLoggedIn = !!token;
      
      if (this.isLoggedIn) {
        this.username = localStorage.getItem('username') || 'User';
        this.avatar = localStorage.getItem('avatar') || '';
        this.role = localStorage.getItem('role') || '';
      } else {
        this.username = '';
        this.avatar = '';
        this.role = '';
      }
    }
  }
}
</script>

<style scoped>
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 250px;
  background-color: #f8f9fa;
  border-right: 1px solid #dee2e6;
  z-index: 999;
  padding-top: 60px; /* Sesuaikan dengan tinggi navbar */
  transition: transform 0.3s ease;
}

/* Responsif untuk layar mobile */
@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
  }

  .sidebar.show {
    transform: translateX(0);
  }
}

.sidebar-content {
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.sidebar-header {
  padding: 15px 20px;
  text-align: center;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 10px;
}

.sidebar-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 10px;
  object-fit: cover;
}

.sidebar-avatar-placeholder {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
  color: #6c757d;
  font-size: 24px;
}

.sidebar-username {
  margin: 0;
  font-weight: 600;
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar-menu-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.menu-group {
  margin-bottom: 8px;
}

.menu-group-title {
  margin: 0 8px 4px 8px;
  padding: 6px 12px;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #e2e8f0;
  color: #4a5568;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.menu-group-title svg {
  color: #3b82f6;
  font-size: 0.9rem;
}

.sidebar-menu {
  list-style: none;
  padding: 0;
  margin: 0 0 8px 0;
}

.sidebar-item {
  display: flex;
  align-items: center;
  padding: 8px 20px;
  color: #333;
  text-decoration: none;
  transition: background-color 0.2s;
  font-size: 0.9rem;
}

.sidebar-item:hover {
  background-color: #e9ecef;
  color: #333;
}

.sidebar-item i, .sidebar-item svg {
  width: 20px;
  margin-right: 10px;
  text-align: center;
}

.sidebar-item.router-link-active {
  background-color: #e9ecef;
  color: #3b82f6;
  font-weight: 500;
}

/* Customize scrollbar */
.sidebar-content::-webkit-scrollbar {
  width: 5px;
}

.sidebar-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.sidebar-content::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 5px;
}

.sidebar-content::-webkit-scrollbar-thumb:hover {
  background: #999;
}
</style>
